import styles from '../DatePicker.module.scss'

import { WEEK_DAYS, WEEK_DAYS_MILEAGE } from '../../constants'

export const Weekdays = () => (
    <thead aria-hidden className={styles.weekdays}>
        <tr>
            {WEEK_DAYS.map(({ value, label }) => (
                <th key={label} aria-label={label}>
                    {value}
                </th>
            ))}
        </tr>
    </thead>
)

export const WeekdaysMileage = () => (
    <thead aria-hidden className={styles.weekdays}>
        <tr>
            {WEEK_DAYS_MILEAGE.map(({ value, label }) => (
                <th key={label} aria-label={label}>
                    {value}
                </th>
            ))}
        </tr>
    </thead>
)
